import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/fi-help-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-78dabbe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trans-bus-stop-wrapper" }
const _hoisted_2 = { class: "trans-bus-stop-info" }
const _hoisted_3 = { class: "trans-bus-stop-number" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "trans-modal-getoff-bus" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($setup.useGetTransBusNumber($setup.props.transferBusStops)) + " 노선 환승 ", 1 /* TEXT */),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "도움말",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleTransferBusStopGuide(true)))
        })
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showTransferBusStopGuide)
        ? (_openBlock(), _createBlock($setup["InfoModal"], {
            key: 0,
            title: "환승 안내",
            confirmButtonTitle: "닫기",
            onOnClickConfirmButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleTransferBusStopGuide(false)))
          }, {
            default: _withCtx(() => [
              ($setup.showParsedModalText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString($setup.transferableBusStop), 1 /* TEXT */),
                    _createTextVNode(" " + _toDisplayString($setup.transferBusGuide), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString($setup.props.transferGuide), 1 /* TEXT */)
                  ]))
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}